/**
 * <ry-testimonial>
 *
 * Customer testimonial / quote card.
 *
 * Usage:
 * <ry-testimonial stars="5">
 *   <img slot="avatar" src="photo.jpg" alt="Jane Doe">
 *   <blockquote>This changed everything.</blockquote>
 *   <span slot="name">Jane Doe</span>
 *   <span slot="role">CTO, Acme Corp</span>
 * </ry-testimonial>
 */

import { RyElement } from '../core/ry-element.js';
import { getIcon } from '../core/ry-icons.js';

export class RyTestimonial extends RyElement {
  setup(): void {
    this.#transformMarkup();
  }

  #transformMarkup(): void {
    if (this.$('[data-ry-target="quote"]')) return;

    const avatarEl = this.querySelector('[slot="avatar"]');
    const quoteEl = this.querySelector('blockquote');
    const nameEl = this.querySelector('[slot="name"]');
    const roleEl = this.querySelector('[slot="role"]');
    const stars = parseInt(this.getAttribute('stars') ?? '0', 10);

    const quoteText = quoteEl?.innerHTML?.trim() ?? '';
    const nameText = nameEl?.textContent?.trim() ?? '';
    const roleText = roleEl?.textContent?.trim() ?? '';

    const avatarHTML = avatarEl
      ? `<div data-ry-target="avatar" class="ry-testimonial__avatar">${avatarEl.outerHTML}</div>`
      : '';

    const starsHTML = stars > 0
      ? `<div data-ry-target="stars" class="ry-testimonial__stars">${Array.from({ length: stars }, () => `<span class="ry-testimonial__star">${getIcon('star')}</span>`).join('')}</div>`
      : '';

    this.innerHTML = `
      ${avatarHTML}
      ${starsHTML}
      <blockquote data-ry-target="quote" class="ry-testimonial__quote">${quoteText}</blockquote>
      <div data-ry-target="attribution" class="ry-testimonial__attribution">
        <span data-ry-target="name" class="ry-testimonial__name">${nameText}</span>
        ${roleText ? `<span data-ry-target="role" class="ry-testimonial__role">${roleText}</span>` : ''}
      </div>
    `;
  }
}

customElements.define('ry-testimonial', RyTestimonial);
